// Typelizer digest 2b7b4fc206009f9c3bafcbfb2eeccd36
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /bank_statement_files */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_statement_files', {}, options),
    method: 'get',
  }),

  /** POST /bank_statement_files */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/bank_statement_files', {}, options),
    method: 'post',
  }),

  /** GET /bank_statement_files/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_statement_files/:id', params, options),
    method: 'get',
  }),

  /** DELETE /bank_statement_files/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/bank_statement_files/:id', params, options),
    method: 'delete',
  }),
}
